PJQ.collections.rfq = PJQ.collections.rfq ? PJQ.collections.rfq : {};
PJQ.models.rfq = PJQ.models.rfq ? PJQ.models.rfq : {};
PJQ.views.rfq = PJQ.views.rfq ? PJQ.views.rfq : {};